import { httpClient } from '../httpClient';
import {
  ICoinAccount,
  ICoinTransaction,
  PaginatedResponse,
  CoinTransactionQuery,
  PaginationQuery
} from '@packages/global';

export class CoinApi {
  async getAccount(): Promise<ICoinAccount | null> {
    return httpClient.get<ICoinAccount | null>('/user/coins/account');
  }

  async transactionPageList(queryData: PaginationQuery<CoinTransactionQuery>): Promise<PaginatedResponse<ICoinTransaction>> {
    return httpClient.post<PaginatedResponse<ICoinTransaction>>('/user/coins/transactions/page', queryData);
  }
}

export const coinApi = new CoinApi();
